import api from '@/services/api';

/**
 * 售后服务 API（增强版 2026-04-26）
 */

// ========== 售后单管理 ==========

export function applyAfterSales(data) {
  return api.post('/after-sales/apply', data);
}

export function getAfterSalesList(params) {
  return api.get('/after-sales/list', { params });
}

export function getAfterSalesDetail(id) {
  return api.get(`/after-sales/${id}`);
}

export function getAfterSalesActions(id) {
  return api.get(`/after-sales/${id}/actions`);
}

export function cancelAfterSales(id) {
  return api.post(`/after-sales/${id}/cancel`);
}

/**
 * 审核售后（批发商）
 */
export function reviewAfterSales(id, data) {
  return api.post(`/after-sales/${id}/review`, data);
}

export function confirmPickup(id) {
  return api.post(`/after-sales/${id}/pickup`);
}

export function confirmReceive(id) {
  return api.post(`/after-sales/${id}/receive`);
}

export function submitInspection(id, result, note) {
  return api.post(`/after-sales/${id}/inspect`, null, { params: { result, note } });
}

export function confirmShip(id) {
  return api.post(`/after-sales/${id}/ship`);
}

export function confirmReceiveNew(id) {
  return api.post(`/after-sales/${id}/confirm-receive`);
}

export function executeRefund(id) {
  return api.post(`/after-sales/${id}/refund`);
}

export function getRefundReceipt(id) {
  return api.get(`/after-sales/${id}/receipt`);
}

// ========== ⭐ 新增接口（2026-04-26） ==========

/**
 * 退货入库处理（仓库质检+入库/报废）
 */
export function processReturnInstock(id, items) {
  return api.post(`/after-sales/${id}/return-instock`, items);
}

/**
 * 获取退货记录列表
 */
export function getReturnRecords(id) {
  return api.get(`/after-sales/${id}/return-records`);
}

/**
 * 获取可选配送员列表
 */
export function getAvailableDrivers(wholesalerId) {
  return api.get('/after-sales/drivers', { params: wholesalerId ? { wholesalerId } : {} });
}

/**
 * 获取可选仓库列表
 */
export function getAvailableWarehouses(wholesalerId) {
  return api.get('/after-sales/warehouses', { params: wholesalerId ? { wholesalerId } : {} });
}

// ========== 退款管理 ==========

export function getRefundList(params) {
  return api.get('/refunds', { params });
}

export function getRefundDetail(id) {
  return api.get(`/refunds/${id}`);
}

export function confirmRefund(id, providerRef) {
  return api.post(`/refunds/${id}/confirm`, null, { params: { providerRef } });
}

export function rejectRefund(id, reason) {
  return api.post(`/refunds/${id}/reject`, null, { params: { reason } });
}

export function getRefundStats(orderId) {
  return api.get(`/refunds/stats/${orderId}`);
}

// ========== 物流事件 ==========

export function getOrderEvents(orderId) {
  return api.get(`/delivery/orders/${orderId}/events`);
}

export function getTaskEvents(taskId) {
  return api.get(`/delivery/tasks/${taskId}/events`);
}

export function confirmDelivery(taskId, data) {
  return api.post(`/delivery/tasks/${taskId}/deliver`, null, { params: data });
}

export function createPickupTask(data) {
  return api.post('/delivery/tasks/pickup', data);
}

export function reportDeliveryFailure(taskId, reason) {
  return api.post(`/delivery/tasks/${taskId}/fail`, null, { params: { reason } });
}

// ========== ⭐ 售后配送任务（2026-05-04） ==========

/**
 * 创建售后配送任务（换货/补发/退货取件）
 */
export function createAfterSalesDeliveryTask(afterSalesId, data) {
  return api.post(`/after-sales/${afterSalesId}/delivery-task`, data);
}

/**
 * 查询售后单关联的配送任务
 */
export function getAfterSalesDeliveryTask(afterSalesId) {
  return api.get(`/after-sales/${afterSalesId}/delivery-task`);
}

/**
 * 配送员取货确认（从批发商仓库取新货，扣减库存）
 */
export function confirmPickupFromWholesaler(taskId) {
  return api.post(`/after-sales/delivery-task/${taskId}/pickup`);
}

/**
 * 配送员送达确认（售后）
 */
export function confirmAfterSalesDelivery(taskId, data) {
  return api.post(`/after-sales/delivery-task/${taskId}/deliver`, data);
}

/**
 * 换货完成（到档口：取旧货 → 验货 → 给新货 → 同步售后单COMPLETED）
 */
export function confirmExchangeAtStall(taskId, data) {
  return api.post(`/after-sales/delivery-task/${taskId}/exchange-complete`, data);
}

/**
 * 退货取件确认（从档口取退货送回批发商入库）
 */
export function confirmReturnPickup(taskId, data) {
  return api.post(`/after-sales/delivery-task/${taskId}/return-pickup`, data);
}

/**
 * ⭐ 简化流程：批发商处理退货退款（2026-05-11）
 */
export function processReturn(id, data) {
  return api.post(`/after-sales/${id}/process-return`, data);
}
